import { Component, ElementRef, HostListener, Inject, ViewChild
       } from '@angular/core';
import { MatIconRegistry } from '@angular/material';
import { DomSanitizer } from '@angular/platform-browser';

import { DesignStepService
       } from 'collage-designer/design-step/design-step.service';
import { ImagePlaceholder
       } from 'collage-designer/stage/placeholder/image-placeholder';
import { StageConstants } from 'core/constants';
import { Utils } from 'core/utils';
import { ToolboxComponent } from '../toolbox.component';
import { ImageCroppingInformation, ToolboxService } from '../toolbox.service';
import { ImageQualityRatingComponent
       } from 'app/controls/image-quality-rating/image-quality-rating.component'; // tslint:disable-line

@Component({
  selector: 'image-toolbox',
  templateUrl: './image-toolbox.component.html',
  styleUrls: [ '../toolbox.component.scss', './image-toolbox.component.scss', ],
})
export class ImageToolboxComponent extends ToolboxComponent
{
  @ViewChild(ImageQualityRatingComponent) public imageQualityRating: any;
  public imageCroppingInformation: ImageCroppingInformation;
  public domImageId: string;
  public imageUrl: string;
  public imageDimensions: any;
  public imageCropperMaxHeight: number | undefined = undefined;
  public placeholder: ImagePlaceholder;

  public crop: any;
  public editableArea: any = undefined;

  constructor(
      private elem: ElementRef,
      mir: MatIconRegistry,
      sanitizer: DomSanitizer,
      @Inject(ToolboxService) toolboxService,
      @Inject(DesignStepService) designStepService: DesignStepService)
  {
    super(mir, sanitizer, toolboxService);
    this.placeholder = <ImagePlaceholder> this.placeholder;
    this.domImageId = this.placeholder.get('id');

    this.crop = this.placeholder.getBoundingBox();
    if (designStepService.getDesignStepConfig()
        .imageCropperSettings.showEditableAreaMargins) {
      this.editableArea = this.placeholder.approximateEditableArea();
    }

    const imageInfo = JSON.parse(
        this.placeholder.get(StageConstants.ATTRIBUTE_SOURCE_IMG_DIMENSIONS));

    this.imageUrl = this.placeholder.getHref();

    this.imageDimensions = {
        x: 0,
        y: 0,
        width: imageInfo.width,
        height: imageInfo.height,
    };

    let observer = new MutationObserver(mutations => {
      this.onResize(undefined);
    });
    observer.observe(this.elem.nativeElement, {attributes: true});
  }

  public updateBoundingBox(): void
  {
    this.placeholder.applyBoundingBox(this.crop);
    this.imageQualityRating.ngOnChanges(undefined);
  }

  public btnOKClick(): void
  {
    this.updateBoundingBox();
    super.btnOKClick();
  }

  @HostListener('window:resize') public onResize(ev): void
  {
    if (Utils.isSmallDevice()) {
      const toolbox = this.elem.nativeElement.querySelector('.image-toolbox');
      const toolboxContent = toolbox.querySelector('.mat-card-content');
      const toolboxButtons = toolbox.querySelector('.buttons');
      // We need to remove 30px because the toolbox has a max-height of
      // 100% - 30px
      // See also: toolboxes/toolboxes.component.scss
      this.imageCropperMaxHeight =
          window.innerHeight - 30 -
          parseInt(window.getComputedStyle(toolbox).margin, 10) * 2 -
          toolbox.querySelector('.mat-card-header').clientHeight -
          parseInt(window.getComputedStyle(toolboxContent).marginBottom, 10) -
          (toolboxContent.querySelector('.image-quality-rating') ?
            toolboxContent.querySelector('.image-quality-rating').offsetHeight :
            0) -
          toolboxButtons.clientHeight -
          parseInt(window.getComputedStyle(toolboxButtons).margin, 10);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/toolboxes/image-toolbox/image-toolbox.component.ts